import {Dropdown} from "react-bootstrap";
import {RELEVANCE_SORT, SORT_VARIANTS, SortType} from "../../utils/productSort";

export default function ProductListSort({sortType, setSortType, withRelevance = false}: { sortType: SortType, setSortType: (sortType: SortType) => void, withRelevance?: boolean }) {
    // Сортировка по релевантности имеет смысл только для результатов поиска
    const variants = (Object.keys(SORT_VARIANTS) as SortType[]).filter(value => withRelevance || value !== RELEVANCE_SORT);

    return (<div className="d-flex align-items-center gap-2">
        <img src="/images/icon-sort.svg" alt=""/>
        <span className="text-secondary">Сортировка по:</span>
        <Dropdown className="catalog__sort">
            <Dropdown.Toggle as="button" type="button"
                             className="dropdown-toggle catalog__btn-sort">{SORT_VARIANTS[sortType]}</Dropdown.Toggle>
            <Dropdown.Menu>
                {variants.map(value =>
                    <Dropdown.Item key={value} as="button" type="button"
                                   active={value === sortType}
                                   onClick={() => setSortType(value)}>{SORT_VARIANTS[value]}</Dropdown.Item>)}
            </Dropdown.Menu>
        </Dropdown>
    </div>)
}
